module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-wrapper"
  }, [_c('div', {
    staticClass: "columns centered"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRequiredInformationFile(_vm.file)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-data"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Название файла"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.file.name),
      callback: function($$v) {
        _vm.$set(_vm.file, "name", $$v)
      },
      expression: "file.name"
    }
  }), _vm._v(" "), (!_vm.file.file) ? _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.handleloadFile
    }
  }, [_vm._v("\n        Загрузить документ\n      ")]) : _c('span', [_c('span', {
    staticClass: "link"
  }, [_vm._v(_vm._s(_vm._f("path")(_vm.file.file)))]), _vm._v(" "), _c('span', {
    staticClass: "delete-file",
    on: {
      "click": function($event) {
        return _vm.deleteFile()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('input', {
    ref: "loadFile",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadFile
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-299bcaa4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/BankRequirementFile.vue
// module id = 914
// module chunks = 0